import { createReducer, on } from '@ngrx/store';
import {
  addNotification,
  loadUnreadNotificationsSuccess,
  loadUnreadNotificationsFailure,
  markNotificationAsRead,
  markNotificationAsReadFailure,
  loadUnreadNotifications,
  markNotificationAsReadSuccess,
} from './notification.actions';
import { ResetAllStores } from '../app/app.actions';

export interface NotificationState {
  loading: boolean;
  notifications: any;
  error: string | null;
}

export const initialState: NotificationState = {
  loading: false,
  notifications: {
    Value: [],
    IsSuccess: false,
    StatusCode: null,
    IsFailure: false
  },
  error: null,
};

export const notificationReducer = createReducer(
  initialState,

  on(loadUnreadNotifications, (state) => ({
    ...state,
    loading: true,
  })),

  on(loadUnreadNotificationsSuccess, (state, { notifications }) => ({
    ...state,
    loading: false,
    notifications
  })),

  on(addNotification, (state, { notification }) => ({
    ...state,
    notifications: {
      ...state.notifications,
      Value: [...state.notifications.Value, notification]
    }
  })),

  on(markNotificationAsReadSuccess, (state, { notificationId }) => ({
    ...state,
    notifications: {
      ...state.notifications,
      Value: (state.notifications.Value || []).map((n: any) =>
        n.Id === notificationId ? { ...n, IsRead: true } : n
      )
    }
  })),

  on(markNotificationAsReadFailure, (state, { error }) => ({
    ...state,
    error
  })),
  on(ResetAllStores, () => initialState),
);
